import styled from 'styled-components'

import { CustomActionIcon, DropdownActionButton } from '../Toolbar/styles'
import type { TableSelectionAxis } from './core'

export const CONTROLS_GAP = 2
export const TRIGGER_THICKNESS = 12
export const INSERT_HOTSPOT_SIZE = 14
export const INDICATOR_THICKNESS = 2

export const OverlayRoot = styled.div`
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 200;
`

export const TriggerButton = styled.button<{ active?: boolean; axis: TableSelectionAxis }>`
    pointer-events: auto;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: ${({ active }) => (active ? 'var(--color-theme-6)' : 'var(--color-gray-300)')};
    color: transparent;
    border-radius: 999px;
    cursor: pointer;
    padding: 0;
    z-index: 1;
    opacity: ${({ active }) => (active ? 1 : 0.72)};
    transition: background-color 120ms ease, opacity 120ms ease;

    &:hover {
        background: var(--color-theme-5);
        opacity: 1;
    }
`

export const InsertHotspot = styled.button`
    pointer-events: auto;
    position: absolute;
    width: ${INSERT_HOTSPOT_SIZE}px;
    height: ${INSERT_HOTSPOT_SIZE}px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: var(--color-white);
    color: var(--color-theme-6);
    border-radius: 999px;
    box-shadow: 0 3px 12px rgba(15, 23, 42, 0.12);
    cursor: pointer;
    padding: 0;
    z-index: 2;
`

export const InsertIndicator = styled.div<{ axis: TableSelectionAxis }>`
    position: absolute;
    background: var(--color-theme-6);
    border-radius: 999px;
    pointer-events: none;
    ${({ axis }) => (axis === 'column' ? `width: ${INDICATOR_THICKNESS}px;` : `height: ${INDICATOR_THICKNESS}px;`)}
`

export const SelectionOutlineSegment = styled.div`
    position: absolute;
    pointer-events: none;
    background: var(--color-theme-6);
    border-radius: 999px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.92);
`

export const FloatingToolbar = styled.div`
    pointer-events: auto;
    position: relative;
    z-index: 24;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    padding: 6px;
    border-radius: 8px;
    background: var(--color-white);
    border: 1px solid var(--color-gray-200);
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14);
`

export const ToolbarDropdownContainer = styled.div`
    position: relative;
    pointer-events: auto;
`

export const ToolbarDropdownSurface = styled.div<{ width?: number }>`
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 25;
    min-width: ${({ width }) => (width ? `${width}px` : '160px')};
    padding: 6px;
    border-radius: 8px;
    background: var(--color-white);
    border: 1px solid var(--color-gray-200);
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
`

export const ToolbarDropdownItem = styled.button<{ active?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border: none;
    border-radius: 6px;
    background: ${({ active }) => (active ? 'rgba(56, 56, 56, 0.05)' : 'transparent')};
    color: var(--color-black);
    font-size: 13px;
    line-height: 20px;
    text-align: left;
    cursor: pointer;

    &:hover {
        background: rgba(56, 56, 56, 0.08);
    }
`

export const ContextMenuSurface = styled.div`
    pointer-events: auto;
    min-width: 180px;
    padding: 6px;
    border-radius: 8px;
    background: var(--color-white);
    border: 1px solid var(--color-gray-200);
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
`

export const ContextMenuItem = styled.button<{ danger?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 10px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: ${({ danger }) => (danger ? 'var(--color-danger-600, #dc2626)' : 'var(--color-black)')};
    font-size: 13px;
    line-height: 20px;
    text-align: left;
    cursor: pointer;

    &:hover {
        background: ${({ danger }) => (danger ? 'rgba(220, 38, 38, 0.08)' : 'var(--color-gray-50)')};
    }
`

export const ContextMenuDivider = styled.div`
    height: 1px;
    margin: 4px 0;
    background: var(--color-gray-100);
`

export const CombineButtonContainer = styled.div`
    display: flex;
    ${CustomActionIcon} {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    ${DropdownActionButton} {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 1px solid var(--color-gray-200);
    }
`
